// extracted by mini-css-extract-plugin
module.exports = {"TransactionGroupLink":"TransactionGroupLink_TransactionGroupLink__1b90x"};